export class SearchUtilsService {
    static mergeSearchResults(existingResults, newResults) {
        const mergedArray = [];
        existingResults.forEach((result) => mergedArray.push({ ...result }));
        newResults.forEach((result) => mergedArray.push(result));
        return mergedArray;
    }

    static resetSearchState() {
        return {
            results: [],
            facts: [],
            totalNumberOfResults: 0,
            unfilteredNumberOfResults: 0,
            pageNumber: 0,
            pageTotalSize: 0,
            activeFilter: ""
        };
    }

    static resetConversationalState() {
        return {
            messages: [],
            conversationId: null,
            isLoading: false,
            suggestions: [],
            context: null,
            awaitingResponse: null,
            typeWriterToken: null
        };
    }
}